import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Store } from '@ngxs/store';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AuthState } from '../../state-manager/state/auth.state';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class HttpsRequestInterceptor implements HttpInterceptor {

  token: string;
  hash: string;

  constructor(
    protected store: Store,
    private cookieService: CookieService
  ) {
    this.store
        .select(AuthState.CRYPTO)
        .pipe(map(token => {
            if (token) { this.token = token; }
        }))
        .subscribe();

    this.store
        .select(AuthState.HASH)
        .pipe(map(hash => {
            if (hash) { this.hash = hash; }
        }))
        .subscribe();
  }

  private isDownloadFileUrl(requestUrl: string) {
    return requestUrl.includes(environment.apiCadastroSettings.downloadInvestorDocumentUpload);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const domains = ['vxcadastro', 'vxcadastro-stg', 'localhost', 'ms-cotista', 'ms-cotista-stg'];

    const headers: {Authorization: string, AuthorizationHash?: string} = {
      Authorization:  `Basic ${this.token}`
    };

    if (this.hash) { headers.AuthorizationHash = this.hash; }

    for (const [_, domain] of domains.entries()) {
      if (req.url.includes(domain)) {
        const nextReq = this.isDownloadFileUrl(req.url)
          ? next.handle(req.clone({ responseType: 'blob' as 'json', setHeaders: headers }))
          : next.handle(req.clone({ setHeaders: headers }));

        return nextReq
         .pipe(
          tap(event => {
            // all things looking good
          }, error => {
            console.error(error.status);
            console.error(error.message);

            if (error.status === 401) {
              const document = this.cookieService.get('document');

              if (document) {
                const url = `${environment.refreshMiddlewareUrl}?document=${document}&returnUrl=${window.location.href}`;
                window.document.location.href = url;
              } else {
                window.location.href = environment.authMiddlewareUrl;
              }
            }

          })
        );
      }
    }

    return next
      .handle(req.clone())
      .pipe(
          tap(event => {
           // all things looking good
          }, error => {
            console.error(error.status);
            console.error(error.message);

            if (error.status === 401) {
              const document = this.cookieService.get('document');

              if (document) {
                const url = `${environment.refreshMiddlewareUrl}?document=${document}&returnUrl=${window.location.href}`;
                window.document.location.href = url;
              } else {
                window.location.href = environment.authMiddlewareUrl;
              }
            }

          })
        );
  }
}


